<template>
  <div>
<!--    <b-table :items="activity_logs" hover striped bordered thead-class="hidden_header"></b-table>-->
    <b-table :items="activity_logs" hover striped bordered></b-table>
  </div>
</template>

<script>
import axios from "axios";
import {fullURL} from "@/utils";
import store from "@/store";

export default {
  data() {
    return {
      activity_logs: []
    }
  },

  created() {
    const activities = store.state.general.activity_logs
    if (activities) {
      activities.forEach(activity => {
        let detail = activity["full_name"] + " " + activity["activity"]
        this.activity_logs.push({Activity: detail, IPAddress: activity["ip_address"], Date: new Date(activity["createdAt"])})
      })
    } else {
      axios.get(
      fullURL(`/user-activity/all`)
    ).then(({data}) => {
      data.forEach(activity => {
          let detail = activity["full_name"] + " " + activity["activity"]
          this.activity_logs.push({Activity: detail, IPAddress: activity["ip_address"], Date: new Date(activity["createdAt"])})
        })
        store.state.general.activity_logs = data
      }
    )
    }
  },
}
</script>
<!--<style>-->
<!--.hidden_header {-->
<!--  display: none;-->
<!--}-->
<!--</style>-->
